export default function HistoricalAlertsViewController($scope, $rootScope, alertsRepository, $stateParams, $uibModal, $q, gettextCatalog) {

  'ngInject';

  //for update/delete note
  var userEmail = '';
  $scope.noteEditing = false;
  $scope.editing = {};
  $scope.save = {};
  $scope.editNote = {};

  $scope.toggleEditing = function (instance) {
    $scope.editErrorFlag = false;
    $scope.editing[instance.id] = !$scope.editing[instance.id];
    $scope.editNote[instance.id] = instance.text;
    $scope.noteEditing = !$scope.noteEditing;
  };

  //update note
  $scope.updateNote = function (alertId, noteId, instance) {
    $scope.editErrorFlag = false;
    if ($scope.editNote[instance.id] !== '') {
      $scope.save[instance.id] = !$scope.save[instance.id];
      instance.updatedBy = $rootScope.currentUser.email;
      instance.text = $scope.editNote[instance.id];
      var note = {
        id: instance.id,
        instanceId: instance.instanceId,
        text: instance.text
      };
      alertsRepository.updateNote(alertId, noteId, note)
        .then(function (response) {
          $scope.editing[instance.id] = !$scope.editing[instance.id];
          $scope.save[instance.id] = !$scope.save[instance.id];
        }, function (error) {
          var errorMsg = gettextCatalog.getString('An error occurred while updating the note');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.save[instance.id] = false;
          $scope.editErrorText = errorMsg;
          $scope.editErrorFlag = true;
        });
    }
  }; //update note

  //delete note
  $scope.deleteNote = function (instance) {
    $scope.editErrorFlag = false;
    var alertId = instance.instanceId;
    var noteId = instance.id;
    $scope.save[noteId] = !$scope.save[noteId];
    alertsRepository.deleteNote(alertId, noteId)
      .then(function (response) {
        var elementPos = $scope.instances.indexOf(instance);

        if (elementPos > 0) {
          $scope.instances.splice(elementPos, 1);
        }
        $scope.save[noteId] = !$scope.save[noteId];
      }, function (error) {
        var errorMsg = gettextCatalog.getString('An error occurred while deleting the note');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.save[noteId] = false;
        $scope.editErrorText = errorMsg;
        $scope.editErrorFlag = true;
      });
  }; //delete note

  //load page
  var refresh = function () {
    $scope.loading = true;

    function onError(error) {
      //error
      $scope.loading = false;
      var errorMsg = gettextCatalog.getString('An error occurred while retrieving alert information');
      if (error.data || error.status) {
        if (error.data.message) {
          errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
        } else {
          errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
        }
      } else {
        errorMsg += gettextCatalog.getString('. Please try again later.');
      }
      $scope.onLoadErrorFlag = true;
      $scope.onLoadErrorText = errorMsg;
      return $q.reject();
    }

    alertsRepository.getAlert($stateParams.instanceId).then(function (response) {
      $scope.alert = response.data;
      $scope.equipment = $scope.alert.equipment;
      $scope.isVisible = false;
      if ($scope.alert.series && $scope.alert.series.tags && $scope.alert.series.tags.length > 0) {
        //Checking to see if the alert is visible to the current user by checking the series tag

        var currentUser = $rootScope.currentUser;
        for (var i = 0; i < currentUser.visibleDatapoints.length; i++) {
          var t = $scope.alert.series.tags[0];
          var u = currentUser.visibleDatapoints[i].id;
          if ($scope.alert.series.tags[0] === currentUser.visibleDatapoints[i].id) {
            $scope.isVisible = true;
            break;
          }
        }
      }

      if ($scope.isVisible) {
        return alertsRepository.getAlertHistoryDetails($stateParams.instanceId).then(null, onError);
      }
      return null;
    }, onError).then(function (response) {
      $scope.instances = response.data;
      $scope.currentUserId = $rootScope.currentUser.id;
      $scope.loading = false;
    });
  };

  //open a modal fro new note
  $scope.open = function () {

    var modalInstance = $uibModal.open({
      animation: true,
      template: require('./new-notes/new-note.html'),
      controller: 'HistoricalAlertsViewNewNotesController',
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        alert: function () {
          return $scope.alert;
        } //optional, to pass any items to modal
      }
    });

    function onError() {
      //error
      $scope.loading = false;
      $scope.error = gettextCatalog.getString('Note not added.');
    }

    modalInstance.result.then(function (val) {
      if (val) {
        val['timestamp'] = val.enteredAt;
        val['status'] = 'note';
        val['user'] = val.enteredBy;
        $scope.instances.push(val);
      }
    }, onError);
  };

  refresh();
}